import {makeStyles} from "@material-ui/core/styles"
import {Box, Icon, Popover, useTheme} from "@material-ui/core"
import Button from "@material-ui/core/Button"
import {CirclePicker} from "react-color"
import React, {Fragment} from "react"
import IconButton from "@material-ui/core/IconButton"
import UserEvent from "../../core/UserEvent"
import i18n from "../../core/i18n"
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
    root: {
        borderRadius: '0px',
        padding: '0',
    },
    label: {
        padding: '0.3em',
        borderRadius: '0px',
    }
}))


function ColorPicker({onChange, value}) {
    const theme = useTheme()
    const spacing = theme.spacing()
    const handleChange = (color, event) => {
        const value = color.hex
        onChange && onChange(new UserEvent({value}, event))
    }
    const handleReset = event => {
        const value = 'unset'
        onChange && onChange(new UserEvent({value}, event))
    }
    return (
        <Box padding={1} display="flex" flexDirection="column">
            <Button onClick={handleReset} size="small" variant="outlined" fullWidth>{i18n.translate('Automatic')}</Button>
            <Box marginY={0.5} />
            <CirclePicker circleSize={20} circleSpacing={spacing} onChange={handleChange} />
        </Box>
    )
}

function ColorToolButton(props) {
    const {value, icon, style = {}, onClick, 'aria-label': ariaLabel} = props
    const classes = useStyles()
    const [anchorEl, setAnchorEl] = React.useState(null)

    const handleMouseDown = event => {
        // event.preventDefault()
        setAnchorEl(event.currentTarget)
    }

    const handleClose = event => {
        // event.preventDefault()
        setAnchorEl(null)
    }

    const handleChange = (event) => {
        const value = event.value
        onClick && onClick(new UserEvent({value}, event))
    }

    const open = Boolean(anchorEl)

    const title = i18n.translate(props.title)

    return (
        <Fragment>
            <IconButton value={value} classes={classes} style={style} onMouseDown={handleMouseDown}
                        title={title} aria-label={i18n.translate(ariaLabel) || title}>
                <Icon fontSize="small" >{icon}</Icon>
            </IconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <ColorPicker onChange={handleChange} />
            </Popover>
        </Fragment>
    )
}

ColorToolButton.propTypes = {
    value: PropTypes.string,
    icon: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func,
    title: PropTypes.string,
    'aria-label': PropTypes.string,
}

export default ColorToolButton